/**
 * 赊购流程接口
 */

import { request } from "@/utils/request"
import type { 
  loan_contract_method,
  loan_credit_getCreditInfo_response,
  loan_credit_ocrIdCard_request,
  loan_credit_ocrIdCard_response,
  loan_credit_verificationThreeFactorAuthCode_request,
  loan_credit_verificationThreeFactorAuthCode_response,
  loan_order_confirm_sign_request,
  loan_order_confirm_sign_response,
  loan_order_contract_create_request,
  loan_order_contract_create_response,
  loan_order_contract_listContractTemp_contractType_request,
  loan_order_contract_listContractTemp_contractType_response,
  loan_order_loanOrder_request,
  loan_order_loanOrder_response,
  loan_order_trialCalculation_request,
  loan_order_trialCalculation_response,
  loan_order_trialConfirm_request,
  loan_order_trialConfirm_response,
  loan_repayment_canBeRepaymentStatus_loanOrderNo_request,
  loan_repayment_loanBillTrial_billId_request,
  loan_repayment_loanBillTrial_billId_response,
  loan_repayment_loanOrderTrial_loanId_request,
  loan_repayment_loanOrderTrial_loanId_response,
  loan_repayment_submit_billId_request,
  loan_repayment_submit_billId_response,
  loan_repayment_submit_settleFull_loanOrderNo_request,
  loan_repayment_submit_settleFull_loanOrderNo_response,
  userInfo_bankCard_add_request,
  userInfo_bankCard_bind_request,
  userInfo_bankCard_bind_verificationCode_id_request,
  userInfo_bankCard_del_id_request,
  userInfo_bankCard_list_response,
  userInfo_bankCard_unbind_id_request,
  userInfo_detail_response,
  userInfo_getRepaymentAccount_response,
  loan_repayment_repaymentSystemConfig_response,
  userInfo_save_request,
  loan_repayment_lastRepaymentDetail_response,
  loan_order_loanOrder_updateRepaymentCard_request,
  loan_repayment_close_repayment_request,
  marketing_loan_disbursement_protoco_request,
  marketing_loan_disbursement_protoco_response,
  loan_cash_faceVerify_request,
  loan_cash_getCreditApplyStatus_response,
  application_loan_cash_faceVerify_request,
  loan_cash_hasLoaningOrder_response,
  loan_cash_detail_orderNo_request,
  loan_cash_detail_orderNo_response,
  loan_cash_trialCalculation_request,
  loan_cash_trialCalculation_response,
  loan_cash_trialConfirm_request,
  loan_cash_trialConfirm_response,
  userInfo_bankCard_sendBindCode_request,
  userInfo_bankCard_verifyBindCode_request,
  userInfo_bankCard_getSupportBankList_request,
  userInfo_bankCard_getSupportBankList_response,
  sso_getTicketInfo_response,
  IdCardExpiredType
} from "./apis.type"
import { formatPathQuery } from "@/utils"
import { data } from "react-router"

// 获取用户授信信息
let times = 0
export const loan_credit_getCreditInfo = () => {
  // let mockUrl = 'https://m1.apifoxmock.com/m1/7121610-6844459-default/loan/credit/getCreditInfo?threeFactorAuth=0'
  // if (times > 0) {
  //   mockUrl = 'https://m1.apifoxmock.com/m1/7121610-6844459-default/loan/credit/getCreditInfo?threeFactorAuth=2'
  // }
  // if (times > 10) {
  //   mockUrl = 'https://m1.apifoxmock.com/m1/7121610-6844459-default/loan/credit/getCreditInfo?threeFactorAuth=1'
  // }
  // times++
  return request<loan_credit_getCreditInfo_response>({
    url: '/loan/credit/getCreditInfo',
    // url: mockUrl,
    method: 'get',
  })
}

// 正反面身份证OCR(一次一张)
export const loan_credit_ocrIdCard = (data: loan_credit_ocrIdCard_request) => {
  return request<loan_credit_ocrIdCard_response>({
    url: '/loan/credit/ocrIdCard',
    // url: 'https://m1.apifoxmock.com/m1/7121610-6844459-default/loan/credit/ocrIdCard',
    method: 'post',
    data,
  })
}

// 发起用户实名认证（发送验证码）
export const loan_credit_sendThreeFactorAuthCode = () => {
  return request({
    url: '/loan/credit/sendThreeFactorAuthCode',
    // url: 'https://m1.apifoxmock.com/m1/7121610-6844459-default/loan/credit/sendThreeFactorAuthCode',
    method: 'post',
  })
}

// 验证用户实名认证
export const loan_credit_verificationThreeFactorAuthCode = (params: loan_credit_verificationThreeFactorAuthCode_request) => {
  let url = '/loan/credit/verificationThreeFactorAuthCode'
  // let url = 'https://m1.apifoxmock.com/m1/7121610-6844459-default/loan/credit/verificationThreeFactorAuthCode'
  return request<loan_credit_verificationThreeFactorAuthCode_response>({
    url: formatPathQuery(url, params),
    method: 'post',
    // params,
  })
}



// 暂存客户信息
export const userInfo_tempSave = (data: userInfo_save_request) => {
  return request({
    url: '/userInfo/tempSave',
    method: 'post',
    data,
  })
}

// 保存用户信息
export const userInfo_save = (data: userInfo_save_request) => {
  return request({
    url: '/userInfo/save',
    // url: 'https://m1.apifoxmock.com/m1/7121610-6844459-default/userInfo/save',
    method: 'post',
    data,
  })
}

// 获取用户信息
export const userInfo_detail = () => {
  return request<userInfo_detail_response>({
    url: '/userInfo/detail',
    method: 'get',
  })
}



// 银行卡列表
export const userInfo_bankCard_list = () => {
  return request<userInfo_bankCard_list_response>({
    url: '/userInfo/bankCard/list',
    // url: 'https://m1.apifoxmock.com/m1/7121610-6844459-default/userInfo/bankCard/list',
    method: 'get',
  })
}

// 添加银行卡
export const userInfo_bankCard_add = (data: userInfo_bankCard_add_request) => {
  return request<string>({
    url: '/userInfo/bankCard/add',
    // url: 'https://m1.apifoxmock.com/m1/7121610-6844459-default/userInfo/bankCard/add',
    method: 'post',
    data,
  })
}

// 获取汇付宝跳转地址 get请求
export const get_hfb_address = (params: {bankCardId: number | string, returnUrl: string}) => {
  return request<string>({
    url: `/userInfo/bankCard/bind/verificationCode/${params.bankCardId}`,
    method: 'get',
    params: {returnUrl: params.returnUrl},
  })
}

// 获取银行验证码 post
export const userInfo_bankCard_verificationCode_add = (data: Partial<userInfo_bankCard_add_request | 'bankCard' | 'reservePhone'> ) => {
  return request({
    url: `/userInfo/bankCard/bind/verificationCode`,
    method: 'post',
    data,
  })
}

// 删除银行卡
export const userInfo_bankCard_del_id = (params: userInfo_bankCard_del_id_request) => {
  return request({
    url: `/userInfo/bankCard/del/${params.id}`,
    method: 'put',
  })
}

// 获取绑定银行卡验证码
export const userInfo_bankCard_bind_verificationCode_id = (params: userInfo_bankCard_bind_verificationCode_id_request) => {
  return request({
    url: `/userInfo/bankCard/bind/verificationCode/${params.id}`,
    method: 'get',
  })
}

// 绑定认证银行卡
export const userInfo_bankCard_bind = (data: userInfo_bankCard_bind_request) => {
  return request({
    url: '/userInfo/bankCard/bind',
    method: 'post',
    data,
  })
}

// 解绑银行卡
export const userInfo_bankCard_unbind_id = (data: userInfo_bankCard_unbind_id_request) => {
  return request({
    url: `/userInfo/bankCard/unbind`,
    method: 'put',
    data
  })
}

// // 还款账户主体信息
// export const userInfo_getRepaymentAccount = () => {
//   return request<userInfo_getRepaymentAccount_response>({
//     url: '/userInfo/getRepaymentAccount',
//     // url: 'https://m1.apifoxmock.com/m1/7121610-6844459-default/userInfo/getRepaymentAccount',
//     method: 'get',
//   })
// }

// 获取贷款试算详情
export const loan_order_trialCalculation = (params: loan_order_trialCalculation_request) => {
  return request<loan_order_trialCalculation_response>({
    url: `/loan/order/trialCalculation/${params.orderNo}`,
    // url: 'https://m1.apifoxmock.com/m1/7121610-6844459-default/loan/order/trialCalculation/1',
    method: 'get',
    // params,
  })
}

// 贷款试算确认申请
export const loan_order_trialConfirm_put = (data: loan_order_trialConfirm_request) => {
  return request<loan_order_trialConfirm_response>({
    url: `/loan/order/trialConfirm/${data.orderNo}`,
    method: 'put',
    data,
  })
}

// 确认签约
export const loan_order_confirm_sign = (data: loan_order_confirm_sign_request) => {
  return request<loan_order_confirm_sign_response>({
    url: '/loan/order/confirm/sign',
    method: 'post',
    data,
  })
}

// 贷款订单详情，根据商城订单
export const loan_order_loanOrder = (params: loan_order_loanOrder_request) => {
  return request<loan_order_loanOrder_response>({
    url: `/loan/order/loanOrder/${params.orderNo}`,
    method: 'get',
    // params,
  })
}

// 创建合同
export const loan_order_contract_create = (data: loan_order_contract_create_request) => {
  return request<loan_order_contract_create_response>({
    url: '/loan/order/contract/create',
    method: 'post',
    data,
  })
}

// 根据合同类型获取对应的合同模板
export const CONTRACT_TYPE = {
  SERVICE_AGREEMENT: 1, // 商品购买服务协议
  DEDUCTION_AUTHORIZATION: 2, // 扣款授权协议
  INFORMATION_QUERY_AND_USE_AUTHORIZATION: 3, // 个人信息查询及使用综合授权书
  FACE_RECOGNITION_AUTHORIZATION: 4, // 人脸识别验证授权书
  ELECTRONIC_SIGN_AUTHORIZATION: 5, // 电子签章授权书
}
export const loan_order_contract_listContractTemp_contractType = (data: loan_order_contract_listContractTemp_contractType_request) => {
  return request<loan_order_contract_listContractTemp_contractType_response>({
    url: `/loan/order/contract/listContractTemp`,
    method: 'post',
    data: data,
  })
}

// 根据账单id，查询还款试算详情
export const loan_repayment_loanBillTrial_billId = (params: loan_repayment_loanBillTrial_billId_request) => {
  return request<loan_repayment_loanBillTrial_billId_response>({
    url: `/loan/repayment/loanBillTrial/${params.billId}`,
    method: 'get',
  })
}

// 根据赊销订单id，查询提前结清试算详情
export const loan_repayment_loanBillSettleFull_loanId = (params: loan_repayment_loanOrderTrial_loanId_request) => {
  return request<loan_repayment_loanOrderTrial_loanId_response>({
    url: `/loan/repayment/loanBillSettleFull/${params.loanId}`,
    method: 'get',
  })
}

// 提交还款
export const loan_repayment_submit_billId = (params: loan_repayment_submit_billId_request) => {
  return request<loan_repayment_submit_billId_response>({
    url: `/loan/repayment/submit/${params.billId}?repaymentMethod=${params.repaymentMethod}`,
    method: 'post',
    // data: params,
  })
}

// 提交结清
export const loan_repayment_submit_settleFull_loanOrderNo = (params: loan_repayment_submit_settleFull_loanOrderNo_request) => {
  return request<loan_repayment_submit_settleFull_loanOrderNo_response>({
    url: `/loan/repayment/submit/settleFull/${params.loanOrderNo}?repaymentMethod=${params.repaymentMethod}`,
    method: 'post',
    // data: params,
  })  
}

// 获取用户是否能还款
export const loan_repayment_canBeRepaymentStatus_loanOrderNo = (params: loan_repayment_canBeRepaymentStatus_loanOrderNo_request) => {
  return request<boolean>({
    url: `/loan/repayment/canBeRepaymentStatus/${params.loanOrderNo}`,
    method: 'get',
  })
}

export const updateRepaymentCard = (data: { loanOrderNo?: string, bankCardId?: number | string}) => {
  return request({
    url: '/loan/order/loanOrder/updateRepaymentCard',
    method: 'post',
    data,
  })
}

// 校验当前用户是否存在认证信息
export const loan_credit_hasAuthInfo = () => {
  return request<boolean>({
    url: `/loan/credit/hasAuthInfo`,
    method: 'post',
  })
}

// 还款系统配置
export const loan_repayment_repaymentSystemConfig = () => {
  return request<loan_repayment_repaymentSystemConfig_response>({
    url: '/loan/repayment/repaymentSystemConfig',
    method: 'get',
  })
}

// 获取用户最后一条还款记录
export const loan_repayment_lastRepaymentDetail = () => {
  return request<loan_repayment_lastRepaymentDetail_response>({
    url: '/loan/repayment/lastRepaymentDetail',
    method: 'get',
  })
}

// 修改贷款订单还款银行卡
export const loan_order_loanOrder_updateRepaymentCard = (data: loan_order_loanOrder_updateRepaymentCard_request) => {
  return request({
    url: '/loan/order/loanOrder/updateRepaymentCard',
    method: 'post',
    data,
  })
}

// 根据还款id关闭还款记录
export const loan_repayment_close_repayment = (params: loan_repayment_close_repayment_request) => {
  return request({
    url: `/loan/repayment/close/repayment/${params.repaymentNo}`,
    method: 'post',
  })
}

// 获取放款现金贷协议
export const marketing_loan_disbursement_protocol = (data: marketing_loan_disbursement_protoco_request) => {
  return request<marketing_loan_disbursement_protoco_response>({
    url: '/marketing/loan/disbursement/protocol',
    method: 'post',
    data
  })
}

// 获取授信人脸认证链接
export const loan_cash_faceVerify = (data: loan_cash_faceVerify_request) => {
  return request<string>({
    url: '/loan/cash/faceVerify',
    method: 'post',
    data
  })
}

// 获取用户授信状态
export const loan_cash_getCreditApplyStatus = () => {
  return request<loan_cash_getCreditApplyStatus_response>({
    url: '/loan/cash/getCreditApplyStatus',
    method: 'get',
  })
}

// 检查当前用户是否存在贷款中的订单
export const loan_cash_hasLoaningOrder = () => {
  return request<loan_cash_hasLoaningOrder_response>({
    url: '/loan/cash/hasLoaningOrder',
    method: 'get',
  })
}

// 获取现金贷款订单明细
export const loan_cash_detail_orderNo = (params: loan_cash_detail_orderNo_request) => {
  return request<loan_cash_detail_orderNo_response>({
    url: `/loan/cash/detail/${params.orderNo}`,
    method: 'get',
  })
}

// 借款试算
export const loan_cash_trialCalculation = (data: loan_cash_trialCalculation_request) => {
  return request<loan_cash_trialCalculation_response>({
    url: '/loan/cash/trialCalculation',
    method: 'post',
    data,
  })
}

// 确认试算结果（提交借款申请）
export const loan_cash_trialConfirm = (data: loan_cash_trialConfirm_request) => {
  return request<loan_cash_trialConfirm_response>({
    url: '/loan/cash/trialConfirm',
    method: 'post',
    data,
  })
}

// 发送绑卡短信验证码 (新)
export const userInfo_bankCard_sendBindCode = (params: userInfo_bankCard_sendBindCode_request) => {
  return request({
    url: `/userInfo/bankCard/sendBindCode/${params.bankCardId}`,
    method: 'post',
    params: { externalType: params.externalType }
  })
}

// 验证短信验证码并绑定银行卡 (新)
export const userInfo_bankCard_verifyBindCode = (data: userInfo_bankCard_verifyBindCode_request) => {
  return request<string>({
    url: '/userInfo/bankCard/verifyBindCode',
    method: 'post',
    data,
  })
}

// 获取支持绑卡的银行卡列表
export const userInfo_bankCard_getSupportBankList = (params?: userInfo_bankCard_getSupportBankList_request) => {
  return request<userInfo_bankCard_getSupportBankList_response>({
    url: '/userInfo/bankCard/getSupportBankList',
    method: 'get',
    params
  })
}

// 获取申请人脸识别认证连接
export const application_loan_cash_faceVerify = (params: application_loan_cash_faceVerify_request) => {
  return request<string>({
    url: '/loan/cash/faceVerify',
    method: 'get',
    params
  })
}


// 获取借款用途下拉框列表
export const loan_cash_getLoanPurposeDict = () => {
  return request<Array<{code: string, name: string}>>({
    url: '/loan/cash/getLoanPurposeDict',
    method: 'get',
  })
}

// 获取二维码凭证信息
export const sso_getTicketInfo = (params: { ticket: string }) => {
  return request<sso_getTicketInfo_response>({
    url: '/sso/getTicketInfo',
    method: 'get',
    params
  })
}

export const loan_credit_checkIdCardExpired = () => {
  return request<IdCardExpiredType>({
    url: '/loan/credit/checkIdCardExpired',
    method: 'post',
  })
}